import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface OnboardingState {
  organisationId: string;
  primaryColor: string;
  logoUrl: string;
  landingType: 'in-app' | 'external';
  externalHomepageUrl: string;
  domain: string;
  hasDomain: boolean;
  websiteCreated: boolean;
  isUpsellJourney: boolean | null;
  previewNotified: boolean;
}

interface OnboardingActions {
  setOrganisationId: (id: string) => void;
  setPrimaryColor: (color: string) => void;
  setLogoUrl: (url: string) => void;
  setLandingType: (type: 'in-app' | 'external') => void;
  setExternalHomepageUrl: (url: string) => void;
  setDomain: (domain: string) => void;
  setHasDomain: (has: boolean) => void;
  setWebsiteCreated: () => void;
  setIsUpsellJourney: (isUpsell: boolean) => void;
  setPreviewNotified: () => void;
  reset: () => void;
}

const initialState: OnboardingState = {
  organisationId: '',
  primaryColor: '',
  logoUrl: '',
  landingType: 'in-app',
  externalHomepageUrl: '',
  domain: '',
  hasDomain: true,
  websiteCreated: false,
  isUpsellJourney: null,
  previewNotified: false,
};

export const useOnboarding = create<OnboardingState & OnboardingActions>()(
  persist(
    (set) => ({
      ...initialState,
      setOrganisationId: (organisationId) => set({ organisationId }),
      setPrimaryColor: (primaryColor) => set({ primaryColor }),
      setLogoUrl: (logoUrl) => set({ logoUrl }),
      setLandingType: (landingType) => set({ landingType }),
      setExternalHomepageUrl: (externalHomepageUrl) => set({ externalHomepageUrl }),
      setDomain: (domain) => set({ domain }),
      setHasDomain: (hasDomain) => set({ hasDomain }),
      setWebsiteCreated: () => set({ websiteCreated: true }),
      setIsUpsellJourney: (isUpsellJourney) => set({ isUpsellJourney }),
      setPreviewNotified: () => set({ previewNotified: true }),
      reset: () => set(initialState),
    }),
    {
      name: 'plus-websites-onboarding',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);
